/**
 * Loading Screen Component
 * 
 * Animated loading screen with gradient background and rotating messages.
 */
import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingScreen = ({ message = 'Loading...' }) => {
  const [currentMessage, setCurrentMessage] = useState(message);
  
  const messages = [
    'Authenticating...',
    'Verifying credentials...',
    'Setting up your workspace...',
    'Almost there...'
  ];

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % messages.length;
      setCurrentMessage(messages[index]);
    }, 2000);

    return () => clearInterval(interval);
  }, [messages.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8fafc',
        zIndex: 9999,
        overflow: 'hidden'
      }}
    >
      {/* BCE Background Blobs */}
      <div className="eclipse" style={{ width: '500px', height: '500px', top: '-100px', left: '-100px' }} />
      <div className="planet1" style={{ width: '450px', height: '450px', bottom: '-100px', right: '-100px' }} />
      
      <Box
        sx={{
          textAlign: 'center',
          color: '#1e3a5f',
          position: 'relative',
          zIndex: 1
        }}
      >
        {/* BCE Logo or Icon */}
        <Box
          sx={{
            width: 80,
            height: 80,
            margin: '0 auto 24px',
            borderRadius: '50%',
            background: 'rgba(89, 92, 234, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <CircularProgress
            size={50}
            thickness={4}
            sx={{
              color: '#595cea'
            }}
          />
        </Box>

        {/* App Name */}
        <Typography
          variant="h4"
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 700,
            marginBottom: 2,
            color: '#1e1e1e'
          }}
        >
          BCE SOW Generator
        </Typography>

        {/* Loading Message */}
        <Typography
          variant="body1"
          sx={{
            fontFamily: 'DM Sans, sans-serif',
            color: 'rgba(30, 30, 30, 0.7)',
            animation: 'pulse 2s ease-in-out infinite',
            '@keyframes pulse': {
              '0%, 100%': { opacity: 0.6 },
              '50%': { opacity: 1 }
            }
          }}
        >
          {currentMessage}
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingScreen;
